import React from 'react'
import { styled, Tooltip } from '@mui/material'
import { ICellRendererParams } from 'ag-grid-community'
import { intl } from '../../../../i18n'
import { TicketTypeIcon } from './TicketTypeIcon'

const RootDiv = styled('div')({
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 0,
  margin: 0,
})

interface Props extends ICellRendererParams {
  value: string
}

/**
 * アイコン列の描画専用コンポーネント
 * 編集はIconCellEditorで行う（クリック）
 */
export const IconCellRenderer: React.FC<Props> = ({ value, data }) => {
  // プリセットの場合は編集不可なのでツールチップを表示しない
  const isEditable = !data?.isPreset
  const iconContent = <TicketTypeIcon value={value} />

  return (
    <RootDiv sx={{ cursor: isEditable ? 'pointer' : 'default' }}>
      {isEditable ? (
        <Tooltip
          title={intl.formatMessage({ id: 'ticketType.icon.tooltip' })}
          arrow={true}
        >
          {iconContent}
        </Tooltip>
      ) : (
        iconContent
      )}
    </RootDiv>
  )
}
